import { useContext } from 'react';

import { AppContext } from '@r-app/app-context';
import { RenderPanel, RenderPanelProps } from './render-panel';
import { DIMENSION_FONT_SIZE } from '@r-core';

export const PANEL_GROUP_SPACING = 18;

export const RenderPanels = (props: RenderPanelProps): React.ReactElement => {
	const { panelId, islandId } = props;
	const { controller: { kitchen, options }} = useContext(AppContext);

	const island = kitchen.design.islands.findById(islandId);
	const panel = island?.panels.findById(panelId);

	if (panel?.isSidePanel || panel?.isBackPanel) {
		const groupedPanels = island.panels.children.filter((p) => panel.isSidePanel ? p.isSidePanel : p.isBackPanel);
		if (groupedPanels.length > 1) {
			const totalWidth = groupedPanels.reduce((sum, p) => sum + p.size.width, 0) + (PANEL_GROUP_SPACING * (groupedPanels.length - 1));
			let cursor = -totalWidth / 2;
			return <>
				{groupedPanels.map((p) => {
					const groupOffsetX = cursor + (p.size.width / 2);
					cursor += p.size.width + PANEL_GROUP_SPACING;
					const displayLabel = p.label.split(' ').pop() ?? p.label;
					return (
						<g key={p.id}>
							<RenderPanel panelId={p.id} islandId={islandId} offsetX={groupOffsetX} />
							<text
								x={groupOffsetX}
								y={-(p.size.height) - 8}
								textAnchor="middle"
								fontSize={options.dimensionFontSizeFactor * 2}
								fontWeight="bold"
								className="rta-designer-component-measure rta-noselect"
							>
								{displayLabel.charAt(0).toUpperCase() + displayLabel.slice(1)}
							</text>
							{(() => {
								const sign = Math.sign(groupOffsetX);
								const fx = groupOffsetX - (sign * ((p.size.width / 2) + 0.75));
								const fy = -(p.size.height / 2);
								return <text
									x={fx}
									y={fy}
									transform={`rotate(${sign * -90}, ${fx}, ${fy})`}
									textAnchor="middle"
									fontSize={options.dimensionFontSizeFactor * 2}
									fontWeight="bold"
									className="rta-designer-component-measure rta-noselect"
								>
									Front
								</text>;
							})()}
						</g>
					);
				})}
			</>;
		}
	}

	return <RenderPanel {...props} />;
};
